import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotVideos from './components/HotVideos';
import RecommendedSection from './components/RecommendedSection';
import { videos } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';

export default function Home() {
  const latestVideos = videos.slice(0, 4);

  return (
    <>
      <HeroBanner />

      <CategoryNav />

      <HotVideos />

      <section className="py-10 md:py-14 bg-background-50">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="w-1 h-6 rounded-full bg-secondary-500"></div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                最新更新
              </h2>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {latestVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>
      </section>

      <RecommendedSection />

      <section className="py-12 md:py-16 bg-accent-500">
        <div className="w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
            随时随地，畅享高清视频
          </h2>
          <p className="text-base text-background-50/80 mb-8 max-w-lg mx-auto">
            海量内容持续更新，手机、电脑、平板多端同步，下载久久视频APP开启你的观影之旅
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-accent-600 font-medium hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-apple-fill text-xl"></i>
              App Store 下载
            </a>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/15 text-background-50 border border-background-50/30 font-medium hover:bg-background-50/25 transition-colors whitespace-nowrap"
            >
              <i className="ri-android-fill text-xl"></i>
              Android 下载
            </a>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 bg-background-50">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
            为什么选择久久视频
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: 'ri-hd-line', title: '超清画质', desc: '支持4K高清播放，给你影院级观影体验' },
              { icon: 'ri-speed-up-line', title: '极速加载', desc: '全球CDN加速，秒开不卡顿流畅播放' },
              { icon: 'ri-stack-line', title: '海量片库', desc: '数万部影视动漫综艺，内容持续更新中' },
              { icon: 'ri-smartphone-line', title: '多端同步', desc: '手机电脑平板无缝切换，随时随地观看' },
            ].map((item) => (
              <div key={item.title} className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
                <div className="w-14 h-14 rounded-2xl bg-primary-50 flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-2xl text-primary-600`}></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}